import { GetItemDataByIdQuery } from 'packages/shared/definitions/types';

import { useGetMasterAddToCart } from './useGetMasterAddToCart';
import { useGetTrackMasterAddToCartFail } from './useGetTrackMasterAddToCartFail';

// TODO: `useTrackToCartAsync` and `useTrackToCartFailedAsync` temporarily use the `shouldUseCatalogId` parameter
// to handle product identifiers, as Wishlist does not yet support `catalogId`.

// The `shouldUseCatalogId` flag indicates which identifier to use: if `true`, it uses `catalogId`;
// otherwise, it defaults to the existing `id`. This flag will be removed once Wishlist fully supports `catalogId`

export const useTrackToCartAsync = (
  productIds: (string | number)[],
  listName: string,
  shouldUseCatalogId?: boolean
) => {
  const trackAddToCart = useGetMasterAddToCart(listName);
  return async (
    product: NonNullable<GetItemDataByIdQuery['vpProductById']>
  ) => {
    await trackAddToCart(
      product as Parameters<typeof trackAddToCart>[0],
      product.catalogMasterId!.toString(),
      productIds.findIndex(
        (id) =>
          String(id) ===
          String(product[shouldUseCatalogId ? 'catalogId' : 'id'])
      ) + 1
    );
  };
};

export const useTrackToCartFailedAsync = (
  productIds: (string | number)[],
  listName: string,
  shouldUseCatalogId?: boolean
) => {
  const track = useGetTrackMasterAddToCartFail(listName);
  return async (
    errorMessage: string,
    product: NonNullable<GetItemDataByIdQuery['vpProductById']>
  ) => {
    await track(
      product as Parameters<typeof track>[0],
      product.catalogMasterId!.toString(),
      productIds.findIndex(
        (id) =>
          String(id) ===
          String(product[shouldUseCatalogId ? 'catalogId' : 'id'])
      ) + 1,
      errorMessage
    );
  };
};
